import { render, staticRenderFns } from "./destroy-target.vue?vue&type=template&id=4f46536b&scoped=true"
import script from "./destroy-target.vue?vue&type=script&lang=js"
export * from "./destroy-target.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f46536b",
  null
  
)

export default component.exports